<bn-web-ui-dropdown-menu
  [aboveLoader]="true"
  [items]="menuItems()"
  [options]="{ align: 'end', closeOnItemClick: false, overflowEscape: true }"
  (clickAction)="onMenuAction($event)">
  <button
    bn-web-ui-button
    buttonStyle="rounded"
    class="bn-event-logs-group-by__trigger"
    data-e2e="GroupByPill"
    itemStyle="stroke"
    size="sm"
    trigger
    type="button"
    [lessPadding]="true">
    <fa-icon
      class="me-0 me-xl-1"
      icon="layer-group" />
    <span class="d-none d-xl-inline-block">Group</span>
    @if (activeDims().length) {
      <bn-web-ui-badge
        class="ms-1"
        color="info"
        data-e2e="GroupByCountBadge"
        size="xxs">
        {{ activeDims().length }}
      </bn-web-ui-badge>
    }
  </button>

  @if (activeDims().length) {
    <div
      class="bn-event-logs-group-by__active"
      content-top>
      <span class="bn-event-logs-group-by__panel-title">Group by (combine for nested keys)</span>

      @for (dimension of activeDims(); track dimension.dimension; let index = $index, last = $last) {
        <div
          class="bn-event-logs-group-by__active-row"
          data-e2e="GroupByActiveRow">
          <span class="bn-event-logs-group-by__order">{{ index + 1 }}</span>
          <fa-icon
            class="bn-event-logs-group-by__panel-icon"
            [icon]="dimension.icon" />
          <span class="bn-event-logs-group-by__panel-name">{{ dimension.label }}</span>
          <button
            aria-label="Move up"
            class="bn-event-logs-group-by__icon-button"
            data-e2e="GroupByMoveUp"
            type="button"
            [disabled]="index === 0"
            (click)="moveUp(index)">
            <fa-icon icon="chevron-up" />
          </button>
          <button
            aria-label="Move down"
            class="bn-event-logs-group-by__icon-button"
            data-e2e="GroupByMoveDown"
            type="button"
            [disabled]="last"
            (click)="moveDown(index)">
            <fa-icon icon="chevron-down" />
          </button>
          <button
            aria-label="Remove"
            class="bn-event-logs-group-by__icon-button"
            data-e2e="GroupByRemove"
            type="button"
            (click)="remove(dimension.dimension)">
            <fa-icon icon="xmark" />
          </button>
        </div>
      }

      <div class="bn-event-logs-group-by__divider"></div>
    </div>
  }
</bn-web-ui-dropdown-menu>
